import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Popover, Typography } from '@mui/material';
import { Flex } from '@synthetica-ai/components';
import { startCase } from 'lodash';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'routes/config';
import { AccountCircle } from '../../../../utils/material-icons-patch';
const changePasswordPath = PATHS.CHANGE_PASSWORD;
const LoggedUser = ({ onLogout, userInfo }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleChangePassword = () => {
        handleClose(); // Close the popover first
        navigate(changePasswordPath); // Then navigate
    };
    return (_jsxs(Box, { children: [_jsx(Flex, { center: true, children: _jsxs(_Fragment, { children: [_jsx(Typography, { color: "white", variant: "caption", children: startCase(userInfo.username) }), _jsx(IconButton, { onClick: handleClick, children: _jsx(AccountCircle, { color: "white", fontSize: "large" }) })] }) }), _jsx(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, children: _jsx(Flex, { direction: "column", gap: "0.5rem", sx: {
                        p: '1rem',
                        '& > *': {
                            cursor: 'pointer',
                        },
                    }, children: _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "button", onClick: onLogout, children: "Logout" }), _jsx(Typography, { onClick: handleChangePassword, variant: "button", children: "Change Password" })] }) }) })] }));
};
export default LoggedUser;
